export default {
  model: [
    {
      label: 'Nome',
      field: 'name',
      type: 'text'
    },
    {
      label: 'Imagem',
      field: 'file',
      type: 'text',
      condition_field: 'id',
      condition_type_exists: false
    }
  ]
}
